module.exports = __webpack_public_path__ + "img/newBackground.fe8d076d.gif";